import React from 'react';
import './EmptyState.css';

/**
 * EmptyState — for zero-data states.
 *
 * Props:
 *   icon        — ReactNode (lucide icon)
 *   title       — string
 *   description — string
 *   action      — ReactNode (typically a <Button>)
 *   tone        — 'neutral' | 'brand' (brand adds gold accent)
 *   size        — 'sm' | 'md' | 'lg'
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  tone = 'neutral',
  size = 'md',
  className = '',
  children,
}) {
  return (
    <div
      className={`ui-empty ui-empty--${size} ui-empty--${tone} ${className}`}
    >
      {icon && (
        <div className="ui-empty__icon" aria-hidden="true">
          {icon}
        </div>
      )}
      {title && <h3 className="ui-empty__title">{title}</h3>}
      {description && <p className="ui-empty__description">{description}</p>}
      {children}
      {action && <div className="ui-empty__action">{action}</div>}
    </div>
  );
}

export default EmptyState;
